// extracted by mini-css-extract-plugin
export default {"info":"ModalContent_info__KeCA6","title":"ModalContent_title__SXDbs","description":"ModalContent_description__pAuXR"};